import i18n from '../../../../../i18n'
import { DominantHandCt } from '../../../../../model/enums/enums'

export const dominantHand = [
    { value: DominantHandCt.left, label: i18n.t<string>('dominant_hand.left') },
    { value: DominantHandCt.right, label: i18n.t<string>('dominant_hand.right') },
    { value: DominantHandCt.both, label: i18n.t<string>('dominant_hand.both') },
    { value: DominantHandCt.none, label: i18n.t<string>('dominant_hand.none') },
    { value: null, label: i18n.t<string>('core.statistic.not_specified') }
]
